export default {
    home: {
        welcome: "Bienvenue sur DFL !",
    },
};
